export default {
    state: {
          //urlApi: 'http://localhost:8080/',
          //urlBack: 'http://localhost:8000/',
          urlApi: 'https://www.api-email.mohfetcorp.cl/',
          urlBack: 'https://www.mohfetcorp.cl/api-email/',
      },
  };
  